<template>
  <div
    class="pulse-play__pulse">
    <div class="pulse-play__play" />
  </div>
</template>

<script>
export default {
  name: 'VideoPulsePlay',
};
</script>

<style lang="scss" scoped>
.pulse-play__pulse {
  position: relative;
  cursor: pointer;

  &:after, &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border: 1px solid $color--basic-white;
    opacity: 0;
    border-radius: 50%;
    transform: translate(-50%, -50%) scale(1);
    top: 50%;
    left: 50%;
  }

  &:before {
    animation: pulse 5s infinite ease-out;
  }

  &:after {
    animation: pulse 5s infinite .75s ease-out;
  }
}

.pulse-play__play {
  width: 100%;
  height: 100%;
  background-color: $color--basic-blue;
  position: absolute;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-35%, -50%);
    border-top: 0.6em solid transparent;
    border-bottom: 0.6em solid transparent;
    border-left: 0.9em solid $color--basic-white;
  }
}
</style>
